import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

const SWIPE_SENSITIVITY = 30;

/** Данная директива предназначена для вертикального свайпа
 * @Input listening - флаг для активации отслеживания свайпа(по умолчанию true)
 * @Output isSlideUp - возвращает направление свайпа как только преодолён порог SWIPE_SENSITIVITY выраженный в пикселях
 * @Output swipeMove - возвращает расстояние пройденное во время свайпа
 */

@Directive({
  selector: '[sdSwipeY]',
  standalone: true,
})
export class SwipeYDirective {
  @Input() listening = true;
  @Output() swipeMove = new EventEmitter<number>();

  // если плашка закрывается - false, открывается - true
  @Output() isSlideUp = new EventEmitter<boolean>();

  touchMoveY = 0;

  @HostListener('touchstart', ['$event'])
  onTouchStart(e: TouchEvent): void {
    this.touchMoveY = e.changedTouches[0].clientY;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(e: TouchEvent): void {
    if (this.listening) {
      e.stopPropagation();
      const currentTouch = e.changedTouches[0].clientY;
      this.swipeMove.emit(this.touchMoveY - currentTouch);
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(e: TouchEvent): void {
    const touchDistance = this.touchMoveY - e.changedTouches[0].clientY;
    this.touchMoveY = 0;

    if (touchDistance < -SWIPE_SENSITIVITY) {
      this.isSlideUp.emit(false);
    } else if (touchDistance > SWIPE_SENSITIVITY) {
      this.isSlideUp.emit(true);
    }
  }
}
